import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import { SampleRoofPlaneMutation } from '@/gql/graphql';

const SampleRoofPlaneMutationDocument = graphql(`
  mutation SampleRoofPlane($projectId: ID!, $polygon: SolarPolygonInput!) {
    sampleRoofPlane(projectId: $projectId, polygon: $polygon) {
      hasDsm
      pitchDegrees
      azimuthDegrees
    }
  }
`);

export type SampleRoofPlaneVariables = {
  projectId: string;
  polygon: { outer: { lat: number; lng: number }[] };
};

/**
 * Fit a plane to the Google Solar DSM under a polygon the installer drew on the
 * aerial, returning the roof pitch + downslope azimuth to seed a manually drawn
 * face. Returns hasDsm:false with null angles when no DSM covers the polygon —
 * the designer then falls back to a default pitch + the rectangle's long axis.
 */
const useSampleRoofPlane = (
  options?: UseMutationOptions<
    SampleRoofPlaneMutation,
    Error,
    SampleRoofPlaneVariables
  >
) =>
  useMutation({
    mutationFn: (variables: SampleRoofPlaneVariables) =>
      gqlClient.request(SampleRoofPlaneMutationDocument, variables),
    meta: { errorMessage: 'Failed to sample the roof plane' },
    ...options,
  });

export default useSampleRoofPlane;
